import { MetadataSeparator as F, MetadataType as P } from "../../constants/metadata.js";
import { AssetType as V } from "../../../temp-lib/constants/url.js";
import J from "../../../temp-lib/hooks/generic/useApeironPathMaker.js";
import M from "../../../temp-lib/hooks/json/useFetchJson.js";
import { singleOperation as _ } from "../../../temp-lib/util/operation/singleOperation.js";
import * as t from "ramda";
import { useCallback as l } from "react";
let j = null;
const v = "fetch_api_mapping", q = () => {
  const { makePath: N } = J(), D = l(() => j, []), { fetchJson: g } = M({
    url: N(V.Json, "data/replace.json")
  }), S = l(
    () => async () => g(),
    [g]
  ), w = l(async () => {
    t.isNil(j) && (j = await _(v, S()));
  }, [S]), b = l(
    (e, r) => t.is(String, r) && t.endsWith("$lower", e) ? t.toLower(r) : r,
    []
  ), f = l((e, r) => t.is(String, e) || t.is(Number, e) ? e : t.pathOr(null, r, e), []), x = l(
    (e) => {
      const { data: r, key: n, type: c, step: o, newValue: s } = e;
      if (c === "rebuild") {
        const a = t.propOr("", "rename", o);
        if (!t.isEmpty(a) && t.is(Object, s))
          return {
            ...s,
            [a]: f(r, [n])
          };
      }
      return s;
    },
    [f]
  ), m = l(
    (e) => {
      const { arrayInject: r = !1, data: n, dictionary: c, key: o, step: s, type: a } = e, p = t.propOr({}, "rule", s), u = t.propOr([], "references", p);
      let i = t.propOr("", "key", p);
      t.forEach((k) => {
        const [A, d] = t.split(">>", k), T = t.split(".", A), I = b(d, f(n, T));
        i = t.isNil(I) ? i : t.replace(`{${d}}`, String(I), i);
      }, u);
      const h = t.includes("::", i) ? t.split(F, i) : [P.Dictionary, i];
      let y = t.pathOr(null, h, c);
      return y = x({ data: n, key: o, type: a, step: s, newValue: y }), t.isNil(y) ? n : r ? y : t.assoc(o, y, n);
    },
    [f, b, x]
  ), E = l(
    (e) => {
      const { data: r, key: n } = e, c = t.propOr([], n, r), o = t.map(
        (s) => m({ ...e, arrayInject: !0, data: s }),
        c
      );
      return t.assoc(n, o, r);
    },
    [m]
  ), O = l(
    (e, r, n) => {
      if (t.isEmpty(e) || t.isNil(e) || t.isEmpty(n))
        return e;
      const c = t.propOr({}, "0", n), o = t.propOr("", "type", c), s = t.propOr("", "key", c), a = t.remove(0, 1, n);
      if (o === "array") {
        const p = t.propOr([], s, e), u = t.map(
          (i) => O(i, r, a),
          s === "self" ? e : p
        );
        return s === "self" ? u : t.assoc(s, u, e);
      } else if (o === "object") {
        const p = t.propOr(null, s, e), u = O(p, r, a);
        return t.assoc(s, u, e);
      } else if (o === "replace" || o === "rebuild") {
        const p = {
          data: e,
          dictionary: r,
          key: s,
          step: c,
          type: o
        };
        return t.is(Array, t.propOr("", s, e)) ? E(p) : m(p);
      }
      return e;
    },
    [E, m]
  ), K = l(
    (e, r) => {
      let n = e;
      if (!t.isNil(r)) {
        const o = t.pipe(t.keys, t.propOr("", "0"))(e), s = t.propOr([], o, j);
        t.forEach((a) => {
          const u = t.pipe(
            t.propOr("", "target"),
            t.split(","),
            t.map((y) => {
              const [k, A, d] = t.split("|", y);
              return { key: k, type: A, rename: d, rule: a };
            })
          )(a), i = t.propOr({}, o, n), h = O(
            i,
            r,
            u
          );
          n = t.assoc(o, h, n);
        }, s);
      }
      return n;
    },
    [O]
  );
  return {
    data: D,
    fetchData: w,
    injectData: K
  };
};
export {
  q as default
};
//# sourceMappingURL=useInjectPath.js.map
